import React from 'react';
import styled from 'styled-components';
import { useLocation } from '@reach/router';

import Text from 'components/Text';
import Stack from 'components/Stack';
import Row from 'components/Row';
import Link from 'components/Link';
import Icon from 'components/Icon';
import VisuallyHidden from 'components/VisuallyHidden';

import useSiteMetadata from 'hooks/useSiteMetadata';

import { color, media } from 'styles/utils';

const StyledLink = styled(Link)`
  background-color: ${color('teal')};
  color: ${color('white')};
  border-radius: 0.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.25rem;
  max-width: 30px;
  height: 30px;
  transition: opacity 150ms ease-in-out;

  ${media.hover} {
    &:hover {
      opacity: 0.75;
    }
  }
`;

const StyledTitle = styled(Text)`
  font-weight: bold;
`;

export default function ShareLinks() {
  const { siteUrl } = useSiteMetadata();
  const { pathname } = useLocation();
  const fullPath = siteUrl + pathname;

  const socialLinks = {
    Facebook: `https://www.facebook.com/sharer/sharer.php?u=${fullPath}`,
    Twitter: `https://twitter.com/intent/tweet?url=${fullPath}`,
    LinkedIn: `https://www.linkedin.com/sharing/share-offsite/?url=${fullPath}`,
    Mail: `mailto:?body=${fullPath}`,
  };

  return (
    <Stack gap="0.5rem">
      <StyledTitle variant="smallestP" color="darkTeal">
        SHARE
      </StyledTitle>
      <Row colGap="0.5rem" breakpoint={null} justify="flex-start">
        {Object.entries(socialLinks).map(([label, href]) => (
          <StyledLink key={label} href={href} popup>
            <VisuallyHidden>{label}</VisuallyHidden>
            <Icon name={label.toLowerCase()} size="md" />
          </StyledLink>
        ))}
      </Row>
    </Stack>
  );
}
